import { ContactPerson } from '../../../../../types/contactPerson'

export const appendNewPrimaryContact = (
  contacts: ContactPerson[],
  newPrimaryContactData: ContactPerson,
): ContactPerson[] => {
  return [
    ...contacts,
    {
      ...newPrimaryContactData,
      id: undefined,
    },
  ]
}
